import type { DynamicVariable } from "@faire/deprecated-retailer-visitor-shared/lib/tailwindUtils";

export const topVar: DynamicVariable<"--f-topc-top"> = {
  variable: "--f-topc-top",
  className: "top-(--f-topc-top)",
};

export const transitionDurationVar: DynamicVariable<"--f-topc-transition-duration"> =
  {
    variable: "--f-topc-transition-duration",
    className: "duration-(--f-topc-transition-duration)",
  };

export const toastTopVar: DynamicVariable<"--f-topc-toast-top"> = {
  variable: "--f-topc-toast-top",
  className: "top-(--f-topc-toast-top)",
};
